(function () {
  var existing = window.__vanemarMediaCollage;
  if (existing) {
    existing.init(document);
    return;
  }

  var selector = '[data-vm-collage-video]';
  var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  // A slow link never gets past this: hydrate() only runs from play(), so the
  // clip's <source> keeps its data-src and the layered poster <img> — which is
  // a plain lazy image — is the whole of what the visitor downloads.
  function allowsVideo() {
    return window.VMConnection ? window.VMConnection.allowsVideo() : true;
  }

  function shouldPlay() {
    return !document.hidden && allowsVideo() && !(motionQuery && motionQuery.matches);
  }

  function hydrate(video) {
    if (video.dataset.vmCollageHydrated === 'true') return true;
    if (window.VMConnection && window.VMConnection.hydrateVideo) {
      if (!window.VMConnection.hydrateVideo(video)) return false;
      video.dataset.vmCollageHydrated = 'true';
      return true;
    }
    var sources = video.querySelectorAll('source[data-src]');
    Array.prototype.forEach.call(sources, function (source) {
      source.src = source.dataset.src;
    });
    video.dataset.vmCollageHydrated = 'true';
    video.load();
    return true;
  }

  function play(video) {
    if (!shouldPlay() || video.dataset.vmCollageVisible !== 'true') return;
    if (!hydrate(video)) return;
    var attempt = window.VMConnection && window.VMConnection.playVideo
      ? window.VMConnection.playVideo(video)
      : video.play();
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  function pause(video) {
    video.pause();
  }

  function init(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var videos = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) videos.unshift(scope);

    videos.forEach(function (video) {
      if (video.dataset.vmCollageObserved === 'true') return;
      video.dataset.vmCollageObserved = 'true';
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      if (observer) {
        observer.observe(video);
      } else {
        video.dataset.vmCollageVisible = 'true';
        play(video);
      }
    });
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        video.dataset.vmCollageVisible = entry.isIntersecting ? 'true' : 'false';
        if (entry.isIntersecting) play(video);
        else pause(video);
      });
    }, { rootMargin: '250px 0px', threshold: 0.01 });
  }

  function syncPlayback() {
    document.querySelectorAll(selector).forEach(function (video) {
      if (shouldPlay()) play(video);
      else pause(video);
    });
  }

  window.__vanemarMediaCollage = { init: init };
  init(document);

  document.addEventListener('visibilitychange', syncPlayback);
  // Networks change mid-visit — walking out of Wi-Fi, or switching Data Saver
  // on. Clips already downloaded keep playing on a recovery; the point is that
  // ones that never started stay unfetched.
  if (window.VMConnection) window.VMConnection.subscribe(syncPlayback);
  if (motionQuery) {
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', syncPlayback);
    else if (motionQuery.addListener) motionQuery.addListener(syncPlayback);
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll(selector).forEach(function (video) {
      pause(video);
      if (observer) observer.unobserve(video);
    });
  });
})();
